import {get} from 'lodash'
import {createDateColumn} from "helpers/pivotTable"


export const getColumnDefinition = () => {
  return {
    User: {
      isFixed: true,
      key: 'userId',
      label: 'Full Name',
      size: 150,
      data: e => get(e, 'fullName', null),
      visible: true,
      order: 1,
    },
    deviceName: {
      key: 'deviceName',
      label: 'Device Name',
      size: 300,
      data: e => get(e, 'deviceName', null),
      visible: true,
      order: 2,
    },
    remoteAddress: {
      key: 'remoteAddress',
      label: 'IP Address',
      size: 300,
      data: e => get(e, 'remoteAddress', null),
      visible: true,
      order: 3,
    },
    browser: {
      key: 'browser',
      label: 'Browser',
      size: 300,
      data: e => get(e, 'browser', null),
      visible: true,
      order: 4,
    },
    expiryDate: createDateColumn({
      key: 'expiryDate',
      label: 'Expires On',
      size: 200,
      data: e => get(e, 'expiryDate', null),
      visible: true,
      order: 5,
    }),
  }
}